import makeRequest from "api/makeRequest";
import { RequstMethods } from "api/requestMethode";
import url from "api/urls";

export class CenterAdminService {
    static async createCenterAdmin(payload: any) {
        return await makeRequest(url.centerAdmin.create, RequstMethods.POST, payload);
    }

    static async updateCenterAdmin(userId: string, payload: any) {
        return await makeRequest(url.centerAdmin.update + "/" + userId, RequstMethods.PUT, payload);
    }

    static async getAllCenterAdmin(examId: string) {
        return await makeRequest(url.centerAdmin.getAll + "/" + examId, RequstMethods.GET);
    }

    static async toggleSuspend(userId: string) {
        return await makeRequest(url.centerAdmin.toggleSuspend + "/" + userId, RequstMethods.PUT);
    }

    static async resetPassword(userId: string) {
        return await makeRequest(url.centerAdmin.resetPassword + "/" + userId, RequstMethods.PUT);
    }
}